import { render } from "./BovineLastInsertedCard.vue?vue&type=template&id=f3db9eb4"
import script from "./BovineLastInsertedCard.vue?vue&type=script&lang=js"
export * from "./BovineLastInsertedCard.vue?vue&type=script&lang=js"

import exportComponent from "/home/elias/web-farm/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__